module.exports = __webpack_public_path__ + "img/629d7e403b5f3248b06e726c76b85bf9.png";